import { ILiveStreamSettings } from 'AppTypes'

import axios from '@utils/axios-client'

export function fetchLiveStreamSettings (storeId: string) {
  return axios.get(`/api/v1/LiveSetting/${storeId}`).then(response => response.data)
}

export function fetchCameraList (params: any) {
  return axios.get('/api/v1/LiveStream/CameraList', {
    params
  }).then(response => response.data)
}

export function updateLiveStreamSettings (settings: ILiveStreamSettings) {
  axios.post('/api/v1/LiveSetting', settings)
}

export function changeCameraStatus (params: any) {
  if (params.start) {
    axios.post(`/api/v1/LiveStream/StartLiveStream/${params.cameraId}`)
  } else {
    axios.post(`/api/v1/LiveStream/StopLiveStream/${params.cameraId}`)
  }
}
